import { XirpIcon } from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';
import { projectsPlugin } from '@spotify/plugin-confidence-projects';
import {
  ExternalUrlArtifactContent,
  ExternalUrlArtifactListItem,
  createArtifactExtension,
  getCodingSessionRef,
  getCodingSessionUrl,
} from '@spotify/plugin-confidence-projects-react';

const HONK_PROVIDER = 'honk';

const getLegacySessionId = (uri: string): string | undefined => {
  try {
    const { hostname, pathname } = new URL(uri);
    const match = pathname.match(/^\/chirp\/sessions\/([^/]+)$/);
    if (hostname === 'backstage.spotify.net' && match) {
      return match[1];
    }
  } catch {
    return undefined;
  }

  return undefined;
};

const getSessionId = (artifact: AttachmentFragment): string | undefined => {
  const session = getCodingSessionRef(artifact.uri);
  if (session?.provider === HONK_PROVIDER) {
    return session.sessionId;
  }
  return getLegacySessionId(artifact.uri);
};

const getSessionHref = (artifact: AttachmentFragment): string | undefined => {
  if (getLegacySessionId(artifact.uri)) {
    return artifact.uri;
  }
  const session = getCodingSessionRef(artifact.uri);
  return session?.provider === HONK_PROVIDER
    ? getCodingSessionUrl(artifact)
    : undefined;
};

const isXirpForSpotifyCodingSession = (artifact: AttachmentFragment): boolean =>
  getSessionId(artifact) !== undefined;

export const XirpForSpotifyCodingSessionArtifactExtension =
  projectsPlugin.provide(
    createArtifactExtension({
      id: 'xirp-for-spotify-coding-session',
      predicate: isXirpForSpotifyCodingSession,
      icon: () => ({
        Icon: XirpIcon,
        color: 'var(--essential-warning)',
      }),
      label: 'Xirp for Spotify coding session',
      category: 'Coding sessions',
      render: artifact => (
        <ExternalUrlArtifactContent
          artifact={artifact}
          href={getSessionHref(artifact)}
         data-track-source-anchor="718b702ebe;xirp-for-spotify-coding-session-artifact"/>
      ),
      renderListItem: (artifact, { onDelete, onRename, icon }) => (
        <ExternalUrlArtifactListItem
          artifact={artifact}
          icon={icon}
          subtitleLabel="Xirp for Spotify coding session"
          openLabel="Open Xirp for Spotify"
          href={getSessionHref(artifact)}
          onDelete={onDelete}
          onRename={onRename}
         data-track-source-anchor="f0684a1978;xirp-for-spotify-coding-session-artifact-2"/>
      ),
    }),
  );
